import axios from "axios";

const API = axios.create({
baseURL: `${process.env.REACT_APP_SOCKET_URL}/api/suggestions`,
});

// 📖 Get All Plans
export async function getAllSuggestionsByAdmin() {
  try {
    const res = await API.get("/get", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 📖 Get All Plans
export async function getAllPostSuggestionsByAdmin(payload) {
  try {
    const res = await API.post("/post", payload,{
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ➕ Create Plan
export async function createSuggestion(payload) {
  try {
    const res = await API.post("/create", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// ✏️ Update Plan
export async function updateSuggestionByAdmin(suggestionId, payload) {
  try {
    const res = await API.put(`/update/${suggestionId}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}

// 🗑️ Delete Plan
export async function deleteSuggestionByAdmin(suggestionId) {
  try {
    const res = await API.delete(`/delete/${suggestionId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return res.data;
  } catch (err) {
    return { success: false, error: err.response?.data?.error || err.message };
  }
}
